import { iGift, iGiftSearch, iGiftSort } from '@/interface/gift';
import { iResult } from '@/interface/result';
import request from '@/utils/request';

/**
 * 礼物列表
 * @param params
 */
export const listGift = (params: iGiftSearch): Promise<any> => {
  return request({
    url: '/api/v1/omc/live/gift/list',
    params,
  });
};

/**
 * 礼物排序
 * @param params
 * @returns
 */
export const sortGift = (data: iGiftSort): Promise<any> => {
  return request({
    url: '/api/v1/omc/live/gift/sort',
    method: 'put',
    data,
  });
};

/**
 * 新增礼物
 * @param data
 * @returns
 */
export const createGift = (data: iGift): Promise<any> => {
  return request({
    url: '/api/v1/omc/live/gift/add',
    method: 'post',
    data,
  });
};

/**
 * 编辑礼物
 * @param data
 * @returns
 */
export const updateGift = (data: iGift): Promise<any> => {
  return request({
    url: '/api/v1/omc/live/gift/edit',
    method: 'put',
    data,
  });
};

/**
 * 查看礼物信息
 * @param params
 * @returns
 */
export const showGift = (params: { id: number }): Promise<any> => {
  return request({
    url: '/api/v1/omc/live/gift/' + params.id,
    params,
  });
};

/**
 * 礼物启用禁用
 * @param params
 * @returns
 */
export const statusGift = (params: { id: number; enable: boolean }): Promise<any> => {
  return request({
    url: '/api/v1/omc/live/gift/enable',
    method: 'put',
    data: {
      ids: [params.id],
      enable: params.enable,
    },
  });
};
